import { useMemo } from "react";

/**
 * Leitet den aktiven Menüpunkt und Untermenüpunkt aus dem URL-Pfad ab.
 *
 * @param {Array} menuItems - Liste der Menüpunkte (mit .name und .subMenuItems)
 * @returns {{
 *   selectedItemName: string|null,
 *   selectedItemIndex: number,
 *   selectedSubItemIndex: number
 * }}
 */
export function useMenuItemFromURL(menuItems) {
    return useMemo(() => {
        const path = window.location.pathname;
        const parts = path.split("/");

        // Kein aktiver Pfad
        if (path === "/" || !parts[1]) {
            return { selectedItemName: null, selectedItemIndex: -1, selectedSubItemIndex: -1 };
        }

        const selectedItemName =
            parts[1].charAt(0).toUpperCase() + parts[1].slice(1);

        const selectedItemIndex = menuItems.findIndex(
            (item) => item.name.toLowerCase() === parts[1].toLowerCase()
        );

        // Untermenüpunkt nur bei Pfadtiefe 3 und nicht bei "benutzer" (Mandant-Parameter)
        let selectedSubItemIndex = -1;
        if (
            parts.length === 3 &&
            parts[1] !== "benutzer" &&
            selectedItemIndex !== -1
        ) {
            selectedSubItemIndex = menuItems[selectedItemIndex]?.subMenuItems.findIndex(
                (sub) => sub.name.toLowerCase() === parts[2].toLowerCase()
            ) ?? -1;
        }

        return { selectedItemName, selectedItemIndex, selectedSubItemIndex };
    }, [menuItems]);
}
